export default __webpack_public_path__ + "static/media/res-project-3.305c3d6f.jpg";